import { sanity } from "@nnf3d/studio/client";
import { GLOBAL_SETTINGS_QUERY, INITIATIVES_QUERY } from "@nnf3d/studio/queries";
import type { GLOBAL_SETTINGS_QUERY_RESULT, INITIATIVES_QUERY_RESULT } from "@nnf3d/studio/types";
import { queryOptions } from "@tanstack/react-query";

const globalQuery = queryOptions({
	queryKey: ["global"],
	queryFn: async (): Promise<GLOBAL_SETTINGS_QUERY_RESULT[0]> => {
		const globalSettingsResult = await sanity.fetch(GLOBAL_SETTINGS_QUERY);

		if (!globalSettingsResult[0]) {
			throw new Error("Global settings not found");
		}

		return globalSettingsResult[0];
	},
});

const initiativesQuery = queryOptions({
	queryKey: ["initiatives"],
	queryFn: async (): Promise<INITIATIVES_QUERY_RESULT> => {
		const initiativesResult = await sanity.fetch(INITIATIVES_QUERY);

		if (initiativesResult.length === 0) {
			throw new Error("Initiatives not found");
		}

		return initiativesResult;
	},
});

export { globalQuery, initiativesQuery };
